function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon / Meter / energy-stats");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Icon-/-Meter-/-energy-stats",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "computer",
  transform: "translate(4.000000, 8.000000)",
  stroke: "#00148C"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6,0 L50,0 C53.3137085,0 56,2.6862915 56,6 L56,34 C56,37.3137085 53.3137085,40 50,40 L6,40 C2.6862915,40 0,37.3137085 0,34 L0,6 C0,2.6862915 2.6862915,0 6,0 Z",
  id: "Rectangle",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  x1: 3,
  y1: 29.5,
  x2: 53,
  y2: 29.5,
  id: "Path-5"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 15,
  y: 46,
  width: 26,
  height: 3,
  rx: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(18.000000, 42.000000)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 0.5,
  y1: -1.19459997e-13,
  x2: 0.5,
  y2: 2.5,
  id: "Path-6"
}), /*#__PURE__*/React.createElement("line", {
  x1: 19.5,
  y1: -1.19459997e-13,
  x2: 19.5,
  y2: 2.5,
  id: "Path-6"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(9.000000, 4.000000)",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  strokeWidth: 2,
  strokeLinecap: "round",
  cx: 10.5555556,
  cy: 10.6111111,
  r: 10.5555556
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  strokeWidth: 2,
  strokeLinecap: "round",
  points: "16.5236667 1.90488889 10.5555556 10.6111111 17.3216667 18.7093333"
}), /*#__PURE__*/React.createElement("line", {
  x1: 10.5555556,
  y1: 10.6111111,
  x2: 0,
  y2: 10.6111111,
  id: "Path",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 25.3333333,
  y1: 4.16666667,
  x2: 38,
  y2: 4.16666667,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 25.3333333,
  y1: 10.5,
  x2: 38,
  y2: 10.5,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 25.3333333,
  y1: 16.8333333,
  x2: 38,
  y2: 16.8333333,
  id: "Path"
}))));

var SvgEnergyStats = function SvgEnergyStats(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnergyStats, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/energy-stats.0638eedc.svg";
export { ForwardRef as ReactComponent };